import React from "react";
import PropTypes from "prop-types";
import DateTimeField from "./DateTimeField";
import { useI18n } from "Hooks";

const OpenDateField = ({
  dateRange,
  isEditMode,
  isDisabled,
  disabledTooltip,
  testId,
  onValidationError,
}) => {
  const { t } = useI18n(["classRoom", "calendar"]);

  return (
    <DateTimeField
      fieldName="openDate"
      label={t("classRoom:open_date")}
      tooltipText={t("calendar:shows_when_assignment_open")}
      dateRange={dateRange}
      isEditMode={isEditMode}
      isDisabled={isDisabled}
      disabledTooltip={disabledTooltip}
      testId={testId}
      onValidationError={onValidationError}
    />
  );
};

OpenDateField.propTypes = {
  /** Date range constraints */
  dateRange: PropTypes.object,
  /** Whether field is in edit mode */
  isEditMode: PropTypes.bool,
  /** Whether field is disabled */
  isDisabled: PropTypes.bool,
  /** Tooltip to show when disabled */
  disabledTooltip: PropTypes.node,
  /** Test ID for testing */
  testId: PropTypes.string,
  /** Callback when validation error occurs */
  onValidationError: PropTypes.func,
};

OpenDateField.defaultProps = {
  dateRange: null,
  isEditMode: false,
  isDisabled: false,
  disabledTooltip: null,
  testId: "open-date",
  onValidationError: null,
};

export default OpenDateField;
